export default __webpack_public_path__ + "static/media/amazon.0378767d.svg";